import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductMetadata extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMetadata);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMetadata);
  }

  /**
   * Updates product-level metadata when the PDP switches product.
   * @param {VariantUpdateEvent} event
   */
  updateMetadata = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const tagName = this.tagName.toLowerCase();
    const selector = `${tagName}[data-product-id="${this.dataset.productId}"]`;
    const newElement = event.detail.data.html.querySelector(selector) || event.detail.data.html.querySelector(tagName);

    if (!newElement) return;

    if (newElement instanceof HTMLElement) {
      this.dataset.productId = newElement.dataset.productId || this.dataset.productId;
    }

    morph(this, newElement);
  };
}

if (!customElements.get('product-vendor')) {
  customElements.define('product-vendor', class extends ProductMetadata {});
}

if (!customElements.get('product-store-code')) {
  customElements.define('product-store-code', class extends ProductMetadata {});
}
